import { h } from "omi";

import { IconProps } from "@/components";

export function HourglassIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.3333"
        d="M8.0013 8.6207 5.1527 6.247c-.4232-.3527-.6348-.529-.787-.7452a2 2 0 0 1-.2957-.6315c-.0687-.2552-.0687-.5307-.0687-1.0816V1.954m4 6.6667 2.8486-2.3738c.4232-.3527.6348-.529.787-.7452a1.9988 1.9988 0 0 0 .2957-.6315c.0687-.2552.0687-.5307.0687-1.0816V1.954m-4 6.6667-2.8486 2.3738c-.4232.3527-.6348.5291-.787.7452a2.0006 2.0006 0 0 0-.2957.6315c-.0687.2552-.0687.5307-.0687 1.0816v1.8346m4-6.6667 2.8486 2.3738c.4232.3527.6348.5291.787.7452.1348.1916.2349.4053.2957.6315.0687.2552.0687.5307.0687 1.0816v1.8346M2.668 1.954h10.6666M2.668 15.2874h10.6666"
      />
    </svg>
  );
}
